import type { RescheduleScheduling, ScheduleTime } from '@src/core/buyerApiClient';
import type { SchedulingsByDate } from '@src/domains/sale-items/core/reschedule/types';

interface Params {
  schedulingsByDate: SchedulingsByDate;
  date?: string;
  time?: ScheduleTime;
  isWithDateOnly: boolean;
}

export function findRescheduleSchedulingForSelection({
  schedulingsByDate,
  date,
  time,
  isWithDateOnly,
}: Params): RescheduleScheduling | undefined {
  if (!date) return undefined;

  return schedulingsByDate[date]?.find(
    (scheduling) =>
      isWithDateOnly ||
      scheduling.availableScheduleTimes?.some((scheduleTime) => scheduleTime.minutes === time?.minutes),
  );
}
